import { render, staticRenderFns } from "./MultiselectMenu.vue?vue&type=template&id=3fba899a&scoped=true"
import script from "./MultiselectMenu.vue?vue&type=script&lang=js"
export * from "./MultiselectMenu.vue?vue&type=script&lang=js"
import style0 from "./MultiselectMenu.vue?vue&type=style&index=0&id=3fba899a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba899a",
  null
  
)

export default component.exports